import React from "react";
import Loader from 'react-loader-spinner'
import HttpService from '../../utils/Http.services';
import { checkTextTranslation, checkTranslation, getObject, groupBy, translate } from "../../utils/useful";
import { getBoundingClientRect } from "../../utils/functions";
import FixedView from "../FixedView";
import { ChromePicker } from "react-color";
import Modal from "../Modal";
import ButtonAnimated from "../buttons/ButtonAnimated";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import TextInput from "./TextInput";
import { nanoid } from "nanoid";
import LabelTemplate from "./LabelTemplate";
// import LabelTemplateStatic from "./LabelTemplateStatic";

class TemplateSelectInput extends React.Component {
    state = {
        options: [],
        isLoading: false,
        tempData: [],
        current: 'color',
        colorInfo: {},
        currentSelect: '',
        cloneOptions: [],
        defaultValue: { SKU: '1234', name: 'Example Value', title: 'Example Title', barcode: '88664422',qrcode:'88664422' }
        // choosen:[],

    }

    componentDidMount() {
        this.init(true)

    }



    componentDidUpdate(prevProps) {

        // console.log(this.props.data)

        if (prevProps.header.information.items != this.props.header.information.items && this.props.header.information.type === "local") {
            // this.setState({ options: this.props.header.information.items })
            this.init()
        }

        // console.log(this.props.rowData)
        // console.log(prevProps.rowData)

        if (JSON.stringify(this.props.rowData) != JSON.stringify(this.state.rowData) && this.props.header.information.rowDependant === true) {
            // this.setState({ options: this.props.header.information.items })
            this.init()
        }

        if (JSON.stringify(this.props.data) != JSON.stringify(prevProps.data)) {
            // this.setState({ options: this.props.header.information.items })
            this.init()
        }
    }


    checkColor = () => {
        let colorInfo = this.state.colorInfo
        if (this.props.header?.information?.color) {
            colorInfo.color = this.props.header.information.color
        }

        if (this.props.header?.information?.background) {
            colorInfo.background = this.props.header.information.background
        }
        this.setState({ colorInfo })
    }
    init(mount) {


        if (this.props.rowData) {
            this.setState({ rowData: { ...this.props.rowData } })
        }
        // if(!mount){
        //     this.props.changeValue(this.props.header.key, null, this.props.extra) 
        // }


        if (this.props.header.information) {
            if (this.props.header.information.type === "local" || !this.props.header.information.type) {

                let options = this.props.header.information.items
                let fields = this.props.header.information.fields
                if (fields && this.props.header.information.items) {
                    options = []

                    this.props.header.information.items.forEach(item => {
                        options.push({ title: getObject(item, fields.title), value: getObject(item, fields.value) })
                    });
                }

                let filter = { ...this.props.header.information.filter }
                let optionsFilter = {}


                for (const [key, value] of Object.entries(filter)) {
                    if (/\{\{(.*?)\}\}/.test(value)) {

                        let baseValue = value.replace(/{/g, '').replace(/}/g, '')

                        if (key.startsWith('*row') && this.props.rowData) {

                            optionsFilter[key.replace('*row.', '')] = getObject(this.props.rowData, baseValue)

                        } else {

                            if (getObject(this.props.fullData, baseValue)) {
                                // console.log(getObject(this.props.fullData, baseValue))
                                optionsFilter[key] = getObject(this.props.fullData, baseValue)

                            } else if (this.props.variables && this.props.variables[baseValue]) {
                                optionsFilter[key] = this.props.variables[baseValue]
                            } else {
                                return
                            }
                        }
                    }
                }



                let filtered = options?.filter(option => {
                    return Object.keys(optionsFilter).reduce((acc, filter) => {
                        const filterValues = optionsFilter[filter];
                        const optionValue = option[filter];


                        //This line defines what is your match
                        const found = filterValues == optionValue

                        return acc && found;
                    }, true);
                })


                let dataValue
                let choosen
                // if (this.props.data) {
                dataValue = this.props.data ? (typeof this.props.data == "object" ? (this.props.data._id ?? this.props.data.id) : this.props.data) : null
                let found = false
                filtered?.forEach(element => {
                    if (element.value == dataValue) {
                        found = true
                        choosen = element
                    }
                })

                if (!found && this.props.data) {
                    this.props.changeValue(this.props.header.key, null, this.props.extra)
                }

                // }

                this.setState({ options: filtered, choosen })
            } else if (this.props.header.information.type === "api") {
                this.fetch()
            }
        }

    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    toggleOpen = (open) => {
        // console.log("HERE")
        let openState = open != null ? open : !this.state.isOpen

        this.fixedView.showView()

        // if (openState) {
        //     document.addEventListener('mousedown', this.closeBox);
        //     window.addEventListener('scroll', this.getPosition, true);
        //     this.getPosition()

        // } else {
        //     document.removeEventListener('mousedown', this.closeBox);
        //     window.removeEventListener('scroll', this.getPosition);

        // }
        // this.refs.icon.classList.toggle("rotate-180")

        this.setState({ isOpen: openState, data: this.props.data })

    }

    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);

            // this.refs.icon.classList.toggle("rotate-180")

        }
    }


    getPosition = () => {
        // console.log("getPosition")
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left - 10 })
    }


    changeItem = (prop, selected, dontChangeValue) => {

        // console.log("CHANGE")
        var choosen = this.state.choosen
        this.setState({ title: '' }, () => {
            if (this.refs.input)
                this.refs.input.focus()
        })


        choosen = prop

        this.setState({ choosen }, () => {
            this.changeValue()
        })

        setTimeout(() => {
            this.fixedView?.hideView()
        }, 1);


        if (this.state.tempData.length > 0)
            this.setState({ options: this.state.tempData })


    }



    fetch() {

        // console.log("HERE")
        // console.log(this.props.header.information.filter)
        let body = { ...this.props.header.information.filter }
        if (this.props.header.information.sort) {
            body.sort = this.props.header.information.sort
        }

        // console.log(body)
        // console.log(this.props.variables)

        // console.log('this.props.variablesfff',this.props.variables)
        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                let baseValue = value.replace(/{/g, '').replace(/}/g, '')

                if (key.startsWith('*row')) {


                } else {

                    if (getObject(this.props.fullData, baseValue)) {
                        // console.log(getObject(this.props.fullData, baseValue))
                        body[key] = getObject(this.props.fullData, baseValue)

                    } else if (this.props.variables && this.props.variables[baseValue]) {
                        body[key] = this.props.variables[baseValue]
                    } else {
                        // return
                        // console.log('body', body, key)
                        delete body[key]
                    }
                }
                // console.log("VAR")
            }
        }

        // console.log("key", this.props.header.key)
        // console.log(body)
        // console.log(this.props.variables)
        // console.log('this.props.header.information.address', this.props.header.information.address)
        // console.log('body', body)
        // console.log('this.props.data', this.props.data)

        // console.log(body)

        this.setState({ isLoading: true })
        HttpService.request(this.props.header.information.address, body, (fetchResult, fetchError) => {
            // console.log('tppppp')
            // console.log(fetchResult)

            if (fetchError) { return }
            var newData = []
            let result = this.props.header.information.fetchKey ? fetchResult.info[this.props.header.information.fetchKey] : fetchResult.info
            if (Array.isArray(result)) {
                result.forEach(element => {
                    let myData = {}

                    Object.entries(this.props.header.information.fields)?.map(([key, value]) => {
                        myData[key] = getObject(element, value)
                    })

                    // console.log(myData)
                    // var newTitle = this.spliter(element, this.props.header.information.fields.title)
                    // var newValue = this.spliter(element, this.props.header.information.fields.value)
                    newData.push(myData)
                });
            }
            // console.log("NEW DATA")
            // console.log(newData)
            // setTimeout(() => {
            let choosen

            if (this.props.data != null) {
                let found = false
                // console.log(this.props.data)

                newData.forEach(element => {
                    // console.log(element.value)
                    let data = this.props.data
                    if (typeof data == 'object') {
                        data = getObject(data, this.props.header.information.fields.value)
                    }
                    if (element.value == data) {
                        found = true
                        choosen = element
                    }

                });

                // if (found == false) {
                //     this.props.changeValue(this.props.header.key, null, this.props.extra)
                // }

            }

            // console.log("newData", newData)


            let groupByArray = this.props.header?.information?.groupBy
            if (groupByArray) {

                let groupByKeys = []
                let groupByHeaders = []

                groupByArray.forEach(groupByItem => {
                    groupByKeys.push(groupByItem.key)
                    groupByHeaders.push(groupByItem)
                })

                groupBy(newData, groupByHeaders, groupByKeys, 0, (groupedOptions) => {
                    // console.log(groupedOptions)
                    this.setState({ groupedOptions })

                })
            } else {
                this.setState({ groupedOptions: null })
            }


            this.setState({
                choosen,
                options: newData,
                isLoading: false
            })
            // }, 1000);


        })

    }


    spliter(source, string) {
        var stringArray = string.split('.')
        var finalString = source
        stringArray.forEach(element => {
            finalString = finalString[element]
        });
        return finalString
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] === condition) {
                return true
            }
        }
        return false
    }


    changeValue = (e) => {
        // console.log(e.target.value)
        let value = this.state.choosen?.value
        if (value == '') {
            value = null
        }
        this.props.changeValue(this.props.header.key, value, this.props.extra)
    }


    showColor = (prop) => {
        let colorInfo = this.state.colorInfo
        // if (!colorInfo.color) {
        //     colorInfo.color = '#000'
        // }
        this.props.header?.information?.items?.map((element) => {
            if (element.value == prop.value) {
                colorInfo.color = element.color
                colorInfo.background = element.background
            }
        })

        this.setState({ colorInfo, currentSelect: prop.value }, () => {
            this.colorFixedView.showView()
        })
    }
    handleChange = (e) => {
        let color = e.hex
        if (color != 'transparent') {
            color = color + Math.round(e.rgb.a * 255).toString(16)
        }
        // console.log('this.props', this.props)
        let colorInfo = this.state.colorInfo
        colorInfo[this.state.current] = color
        let cloneOptions = this.state.cloneOptions
        console.log('cloneOptions', cloneOptions)
        cloneOptions.map((element) => {
            if (element.value == this.state.currentSelect) {
                element[this.state.current] = color
            }
        })
        this.setState({ cloneOptions, colorInfo })
        // let data = this.props.data ?? {}

        // data[this.state.current] = color
        // console.log(data)
        // // this.setState({ color })
        // this.props.changeValue(this.props.header.key, data, this.props.extra,)

    }

    search = async (value) => {

        // console.log(value)
        this.setState({ title: value })
        if (!this.state.isOpen) {
            this.toggleOpen()
        }

        if (value == "") {
            await this.setState({ options: this.state.tempData })
            await this.setState({ tempData: [] })
        } else {
            if (this.state.tempData.length == 0) {
                await this.setState({ tempData: this.state.options })
            }
            var values = []
            // var values = this.props.data.filter((e) => e.title === value)
            // console.log(this.state.tempData)
            this.state.tempData.forEach(element => {
                if (String(element.title).toLowerCase().includes(String(value).toLowerCase()) || String(element.description).toLowerCase().includes(String(value).toLowerCase())) {
                    values.push(element)
                }
            })
            // console.log(values)

            this.setState({ options: values })

            // }
        }
    }




    renderOption(options, group, level) {

        // console.log(options)
        return (
            <div className="w-100 mt-2 d-flex flex-column text-start">
                {group && (
                    <p className="text-bold font-size-14 mb-1" style={{ paddingLeft: level == null ? 12 : ((level ?? 0) * 10) + 3, paddingRight: level == null ? 12 : ((level ?? 0) * 10) + 10, }}>{checkTranslation(group.label)}</p>
                )}
                {Array.isArray(options) && (
                    options.map((prop, index) => {
                        let selected = false
                        if (this.state.choosen?.value == prop.value) {
                            selected = true
                        }
                        // for (var i = 0; i < this.state.choosen.length; i++) {

                        //     if (prop.value == this.state.choosen[i].value)
                        //         selected = true
                        // }
                        // console.log('optionsoptionsss',prop)
                        return (
                            <div key={index} onClick={() => this.changeItem(prop, selected)} className=" py-2 cursor-pointer select-item-hover flexcb" style={{ backgroundColor: selected ? '#78b2d030' : null, borderBottom: '1px solid #fff' }}>
                                <LabelTemplate
                                    scale={1.6}
                                    widthMM={35}
                                    heightMM={20}
                                    title={this.state.defaultValue.title}
                                    templateId={prop.value}
                                    key={index}
                                    code={this.state.defaultValue.barcode}
                                    text1={this.state.defaultValue.name}
                                    text2={this.state.defaultValue.SKU}
                                    qrcode={this.state.defaultValue.qrcode}

                                />

                            </div>
                        )
                    })
                )}

                {(!Array.isArray(options) && options != null && typeof options == 'object') && Object.entries(options)?.map(([key, value], index) => {
                    return this.renderOption(options[key]?.children, options[key], (level + 1))
                })}


            </div>
        )
    }
    showConfig = () => {
        let cloneOptions = JSON.parse(JSON.stringify(this.state.options))
        this.setState({ cloneOptions }, () => {
            this.configuration.open()
        })

    }

    saveConfig = () => {
        // console.log('this.props.', this.props.header.information)
        // let colorInfo = this.state.colorInfo
        let choosen = this.state.choosen
        let cloneOptions = JSON.parse(JSON.stringify(this.state.cloneOptions))
        let field = {
            information: { ...this.props.header.information },
            key: this.props.header.key
        }
        field.information.items = cloneOptions

        let body = { _id: this.props.variables.frameId, field }
        HttpService.request('updateOneField', body, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            if (this.props.functionsHandler && fetchResult.info) {
                this.props.functionsHandler(null, 'setFields', fetchResult.info.fields)
            }
            cloneOptions.map((element) => {
                if (element?.value == choosen.value) {
                    choosen = element
                }
            })
            this.setState({ options: cloneOptions, choosen }, () => {
                this.configuration.close()
            })
        })
    }
    onDragEnd = (result) => {
        let items = Array.from(this.state.cloneOptions);
        let [reorderItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderItem);
        this.setState({ cloneOptions: items }, () => {
        });
    };
    changeValueInput = (key, value, extra) => {
        // console.log('changeValueInput', key, value)
        let cloneOptions = this.state.cloneOptions
        cloneOptions.map((element) => {
            if (element.value == key) {
                element.title = value
            }
        })
        this.setState({ cloneOptions })
    }
    addNewRow = () => {
        let cloneOptions = this.state.cloneOptions
        cloneOptions.push({ title: '', value: nanoid() })
        this.setState({ cloneOptions })
    }
    removeRow = (key) => {
        let cloneOptions = this.state.cloneOptions
        let cIndex
        let found
        cloneOptions.map((element, index) => {
            if (element.value == key) {
                found = true
                cIndex = index
            }
        })
        if (found) {
            cloneOptions.splice(cIndex, 1)
        }
        this.setState({ cloneOptions })
    }
    render() {
        let dataValue = ''
        if (this.props.data != null) {
            dataValue = typeof this.props.data == "object" ? (this.props.data._id ?? this.props.data.id) : this.props.data
        }
        let info = this.props.header?.information

        // console.log("this.props.data", this.props.data)
        // console.log("this.state.choosen", this.state.choosen)
        // console.log("this.state.options", this.state.options)

        return (
            <div className='w-100' style={{ position: 'relative', }} ref={el => this.currentNode = el}>
                <div className="w-100 h-100 cusrsor-pointer" style={{ position: 'relative' }} onClick={() => !this.props.header.information?.disabled ? this.toggleOpen(true) : ''} >
                    {/* <select value={dataValue} disabled={this.props.disabled || this.props.header.information?.disabled} onChange={e => { this.changeValue(e) }} className=' form-control' style={{ WebkitAppearance: 'none', border: 'none', boxShadow: 'none', backgroundColor: 'transparent', color: '#3b3a40', width: '100%', padding: 0 }}>
                        <option disabled={this.props.header.information.required ? true : false} hidden={this.props.header.information.required ? true : false} value={''}>Select ...</option>
                        {Array.isArray(this.state.options) && this.state.options?.map((prop, index) => {

                            return (
                                <option key={index} value={prop.value}>{prop.title}</option>
                            )
                        })}
                    </select> */}


                    {!this.state.choosen && (
                        <div className="h-100 flexc w-100 cursor-pointer" style={{ padding: '3px 0px 3px 0px' }}>
                            <p className={'  placeholder '}>{this.props.header.information?.placeholder ? checkTextTranslation(this.props.header.information.placeholder) : translate("Select ...")}</p>
                        </div>
                    )}
                    {/* {console.log('this.state.choosenkj', this.state.choosen)} */}
                    {this.state.choosen && (
                        <div className='w-100 flexc'>
                            <div className="h-100 cursor-pointer flexc" style={{ color: this.state.choosen?.color ?? '', backgroundColor: this.state.choosen?.background ?? '', border: this.state.choosen?.background ? '1px solid #eee' : null, height: 26, minWidth: 26, borderRadius: 6 }} >
                                <p className={'  '} >{this.state.choosen.title ? checkTranslation(this.state.choosen.title) : checkTranslation(this.state.choosen.description)}</p>
                                {info?.showDropdownIcon && (
                                    <div className="flexcc " style={{ paddingTop: 3 }}>
                                        <img className="mld-1 " src="/assets/icons/useful/down-arrow (3).png" alt="" height={14} />
                                    </div>
                                )}
                            </div>
                        </div>
                    )}


                    {this.conditionalSettings('showInfo', true) && (
                        <p onClick={() => { if (!this.state.isLoading) { this.props.showInfo(this.props.header.information.filter, this.props.data, this.props.settings.url, this.props.settings.page) } }} style={{ fontSize: 13, color: this.state.isLoading ? '#789' : '#007aff', marginTop: 3, cursor: 'pointer', marginLeft: 3 }}>Show information</p>
                    )}

                    {this.state.isLoading && (
                        <div style={{ position: 'absolute', top: 0, right: 10 }}>
                            <Loader
                                type="Oval"
                                color="rgba(0,122,255,1)"
                                height="25"
                                width="25"
                            />
                        </div>
                    )}

                </div>




                <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={10} bottomOffset={30} zIndex={15} xOffset={-5} minWidth={160} maxWidth={300} rightAlign={false}>

                    <div style={{ display: 'flex', width: '100%', maxWidth: 300, zIndex: 40 }}>

                        <div className={'search-drop-down   py-1 pb-2'} style={{ display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffff', borderColor: '#eee', borderRadius: 6, maxHeight: 250, overflow: 'auto', boxShadow: '0px 0px 30px rgba(0,0,0,0.2)' }}>
                            {/* {(this.props.header.information.isSearchable || true ) && ( 
                            <input onChange={event => this.search(event.target.value)} placeholder={translate("Search ...")} style={{ fontSize: 14, alignSelf: 'stratch', padding: '7px 5px', height: 35, backgroundColor: '', border: '0px', borderBottom: '1px solid #eee' }} className={'text-start text-semibold px-3'} />

                            {/* )} */}
                            {!this.props.header?.information?.required && (
                                <div onClick={() => this.changeItem(null, null)} style={{ cursor: 'pointer', padding: 5, paddingTop: 12, paddingBottom: 3, borderBottomColor: '#eee', borderBottomStyle: 'solid', borderBottomWidth: 0, backgroundColor: '#fff' }}>
                                    <p className="px-2" style={{ margin: 0, color: '#007aff', fontSize: 13 }}>{translate("Clear data")}</p>
                                </div>
                            )}
                            {/* {this.state.options.map((prop, index) => {
                                let selected = false
                                if (this.state.choosen && this.state.choosen.value == prop.value) {
                                    selected = true
                                }
                               
                                return (
                                    <div key={index} onClick={() => this.changeItem(prop, selected)} style={{ cursor: 'pointer', padding: 5, paddingTop: 10, paddingBottom: 10, borderBottomColor: '#fff', borderBottomStyle: 'solid', borderBottomWidth: 1, backgroundColor: selected ? '#78b2d030' : '#fff' }}>
                                        <p className="px-2" style={{ color: '#000', fontSize: 14 }}>{prop.title ? checkTranslation(prop.title) : "[ " + checkTranslation(prop.description) + ' ]'}</p>
                                    </div>
                                )
                            })} */}
                            {this.state.groupedOptions ? (
                                <div>
                                    {Object.values(this.state.groupedOptions).map((group, index) => {
                                        return (
                                            this.renderOption(group.children, group, 1)
                                        )
                                    })}
                                    {this.props.header?.information?.hasColor && (
                                        <button onClick={(e) => { this.showConfig(); e.stopPropagation() }}>
                                            <div style={{}}>
                                                <p>{translate("config")}</p>
                                            </div>
                                            {/* <p>
                                            Configuration
                                        </p> */}
                                        </button>
                                    )}
                                </div>
                            ) : (
                                <>
                                    {this.renderOption(this.state.options)}
                                    {this.props.header?.information?.hasColor && (
                                        <button onClick={(e) => { this.showConfig(); e.stopPropagation() }}>
                                            {/* <div style={{ width: 22, height: 22, borderRadius: 100, backgroundColor: '#000' }}> */}
                                            <div style={{}}>
                                                <p>config</p>
                                            </div>
                                            {/* <p>
                                            Configuration
                                        </p> */}
                                        </button>
                                    )}
                                </>
                            )}

                            {this.state.options?.length == 0 && (
                                <div style={{ cursor: 'pointer', padding: 5, paddingTop: 10, paddingBottom: 10, borderBottomColor: '#eee', borderBottomStyle: 'solid', borderBottomWidth: 1 }}>
                                    <p style={{ textAlign: 'center', margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>{translate("Found Nothing")}</p>
                                    {this.props.header.information.tag && this.state.title != '' && (<p onClick={() => this.addTag()} style={{ textAlign: 'center', margin: 0, color: '#007aff', fontSize: 13, marginTop: 5, marginBottom: 5, cursor: 'pointer' }}>+ ADD THIS</p>)}

                                </div>
                            )}

                        </div>
                        <Modal ref={(e) => this.configuration = e}>

                            <div className="w-100">

                                <div className='w-40 br-8 px-2 py-1' ref={el => this.content = el} style={{ border: '1px solid #eee', pointerEvents: 'all', background: '#fff', fontSize: '10px' }}>
                                    <div style={{ position: "fixed", top: "0", left: "0" }} ref={(el) => (this.setPositionDiv = el)}></div>
                                    <DragDropContext onDragEnd={(result) => this.onDragEnd(result)}>
                                        <Droppable droppableId="droppable">
                                            {(provided) => (
                                                <div className="w-100" style={{ transform: "none" }} {...provided.droppableProps} ref={provided.innerRef}>
                                                    {this.state.cloneOptions.map((prop, index) => {
                                                        // console.log('propqfq', prop)
                                                        return (
                                                            <Draggable key={prop.value} draggableId={prop.value} index={index}>
                                                                {(provided, snapshot) => {
                                                                    if (snapshot.isDragging) {
                                                                        if (!provided.draggableProps) {
                                                                            provided.draggableProps = { style: { boxShadow: "0px 0px 30px #10101090", zIndex: "10" } };
                                                                        }
                                                                        let bound = getBoundingClientRect(this.setPositionDiv);
                                                                        // let scrollTop = this.scrollContainer.scrollTop
                                                                        const offset = { x: bound.left, y: bound.top };
                                                                        let x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
                                                                        let y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
                                                                        // y = y - scrollTop
                                                                        provided.draggableProps.style.left = x + 'px';
                                                                        provided.draggableProps.style.top = y + 'px';
                                                                        provided.draggableProps.style.boxShadow = "0px 0px 10px #10101020";
                                                                        provided.draggableProps.style.zIndex = "10";
                                                                    }
                                                                    return (
                                                                        <div className="py-1 bb-gray flexcb">
                                                                            <div className="fields flexcc br-6 " style={{ transform: "none" }} ref={provided.innerRef} {...provided.draggableProps}>
                                                                                <div className="mx-1" style={{ width: "15px" }} {...provided.dragHandleProps}>
                                                                                    <img style={{ opacity: 0.8 }} src="/assets/icons/drag-and-drop.svg" width="13px" />
                                                                                </div>
                                                                                <button ref={el => this['colorPicker-' + prop.value] = el} className="flexcc mx-2 p-1" style={{ border: '1px solid #dadce0' }} onClick={() => this.showColor(prop)}>
                                                                                    <div style={{ width: 22, height: 22, borderRadius: 100, backgroundColor: prop.background ?? '#e8eaed' }}>
                                                                                    </div>
                                                                                </button>
                                                                                {/* {console.log('prop.value', prop.value)} */}
                                                                                <TextInput header={{ key: prop.value, information: {} }} changeValue={this.changeValueInput} data={prop.title} />
                                                                                {/* <p className="text-normal main-c2 mx-1">{prop.title}</p> */}
                                                                                <button onClick={() => this.removeRow(prop.value)}>
                                                                                    <img src="/assets/icons/trash-red.svg" />
                                                                                </button>
                                                                            </div>


                                                                        </div>
                                                                    )
                                                                }}

                                                            </Draggable>
                                                        )
                                                    })}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                    <button className="text-normal mt-2 flexcc w-100" onClick={() => this.addNewRow()}>
                                        <p>+{translate("Add New")}</p>
                                    </button>
                                    {this.props.showFocus && (
                                        <div onClick={() => this.hideView()} style={{ pointerEvents: 'all', backgroundColor: '#00051050', height: '100%', top: 0, left: 0, position: 'fixed' }}>
                                        </div>
                                    )}
                                    <div className="flexcc mt-2" >
                                        <ButtonAnimated
                                            iconwidth='24px'
                                            onClick={this.saveConfig}
                                            title={translate('save Config')}
                                            textColor={this.props.colors?.textColor}
                                            invert={this.props.colors?.iconInvert}
                                            bg={'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))'}
                                        />
                                    </div>
                                    <FixedView ref={el => this.colorFixedView = el} nodeRef={this['colorPicker-' + this.state.currentSelect]} onHide={this.onHide} topOffset={10} bottomOffset={30} zIndex={15} xOffset={-5} maxWidth={'227px'} width={'100%'} rightAlign={false}>
                                        <div className='w-100 ' style={{ background: '#fff', border: '1px solid #dadce0' }}>

                                            <div className='flexc w-100 mb-1 px-2' style={{}}>
                                                <div className='p-2 text-smaller' style={{ borderBottom: this.state.current == 'color' ? '2px solid #007aff' : null, color: this.state.current == 'color' ? '#007aff' : null, cursor: 'pointer' }} onClick={() => this.setState({ current: "color" })} >
                                                    {translate("Text")}
                                                </div>
                                                <div className='p-2 text-smaller' style={{ borderBottom: this.state.current == 'background' ? '2px solid #007aff' : null, color: this.state.current == 'background' ? '#007aff' : null, cursor: 'pointer' }} onClick={() => this.setState({ current: "background" })} >
                                                    {translate("Background")}
                                                </div>
                                            </div>
                                            <div style={{}} onClick={this.handleClose} />
                                            <ChromePicker color={this.state.colorInfo[this.state.current] ?? '#fff'} onChange={this.handleChange} />
                                        </div>
                                    </FixedView>
                                    {/* <div className='w-100 ' style={{}}>

                                        <div className='flexc w-100 mb-1 px-2' style={{}}>
                                            <div className='p-2 text-smaller' style={{ borderBottom: this.state.current == 'color' ? '2px solid #007aff' : null, color: this.state.current == 'color' ? '#007aff' : null, cursor: 'pointer' }} onClick={() => this.setState({ current: "color" })} >
                                                {translate("Text")}
                                            </div>
                                            <div className='p-2 text-smaller' style={{ borderBottom: this.state.current == 'background' ? '2px solid #007aff' : null, color: this.state.current == 'background' ? '#007aff' : null, cursor: 'pointer' }} onClick={() => this.setState({ current: "background" })} >
                                                {translate("Background")}
                                            </div>
                                        </div>
                                        <div style={{}} onClick={this.handleClose} />
                                        <ChromePicker color={this.state.colorInfo[this.state.current] ?? '#fff'} onChange={this.handleChange} />
                                    </div>
                                    <div className="flexcc" >
                                        <ButtonAnimated
                                            iconwidth='24px'
                                            onClick={this.saveConfig}
                                            title={translate('save Config')}
                                            textColor={this.props.colors?.textColor}
                                            invert={this.props.colors?.iconInvert}
                                            bg={'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))'}
                                        />
                                    </div> */}
                                </div>


                            </div>
                        </Modal>
                    </div>
                </FixedView>


            </div>

        );
    }
}

export default TemplateSelectInput;
